import React from "react";
import { useLocation } from "react-router-dom";
import style from "../../css/mainCSS/footer.module.css";
import { useSelector } from "react-redux";
import { Image } from "react-bootstrap";

export const FooterPart = (props) => {
  const { title = "", children } = props;
  return (
    <div className={style.part_container}>
      <div className={style.part_title}>{title}</div>
      {children}
    </div>
  );
};

function Footer(props) {
  const location = useLocation();
  const path = location.pathname.split("/")[1];
  const exception_page = [
    "login", "cart", "print", "register", "midtrans", "user_profile",
    "seller_dashboard", "create_store", "reset_password", "ecosystem_login"
  ];
  const exception_flag = exception_page.includes(path);
  const channelWALink = `https://whatsapp.com/channel/0029VaAkcXNLdQeUXSFA8x03`
  const logo = useSelector((s) => s.global.storeLogo) || null;

  // view
  if (exception_flag) return <></>;
  return (
    <div className={`body_part_container ${style.container}`}>
      <div style={{ display: 'flex', gap: '0.5rem', flexWrap: 'wrap' }}>
        <FooterPart title="Bantuan">
          <a href="">{`Cara Pemesanan`}</a>
          <a href="/terms">{`Syarat & Ketentuan`}</a>
          <a href="/privacy">{`Kebijakan Privasi`}</a>
        </FooterPart>
        <FooterPart title="Hubungi Kami">
          <a href="">
            <i className="bi bi-envelope" />
            {`sales@multipro.co.id`}
          </a>
          <a href="">
            <i className="bi bi-telephone-fill" />
            {`(CS) +62 877 75041 808`}
          </a>
          <a href="">
            <i className="bi bi-telephone-fill" />
            {`(021) 2942 9151 || (021) 6627 567 || (021) 6627 626`}
          </a>
          {/* <a href="">
          <i className="bi bi-telephone-fill" />
          {`(021) 6627 567`}
        </a>
        <a href="">
          <i className="bi bi-telephone-fill" />
          {`(021) 6627 567`}
        </a> */}
          <a href={channelWALink} target="_blank">
            <i className="bi bi-whatsapp" />
            {`Channel Multipro.id`}
          </a>
        </FooterPart>
        <FooterPart title="Ikuti Kami">
          <a href={`https://www.youtube.com/@multiproid?app=desktop`} target="blank">
            <i className="bi bi-youtube" />
            {`multipro.id`}
          </a>
          <a href={`https://www.instagram.com/multipro.id`} target="blank">
            <i className="bi bi-instagram" />
            {`@multipro.id`}
          </a>
          <a href={`https://www.tiktok.com/@multipro.id`} target="blank">
            <svg xmlns="http://www.w3.org/2000/svg"
              width="14" height="14" fill="currentColor" className="bi bi-tiktok" viewBox="0 0 16 16"
              style={{ marginRight: '0.5rem' }}
            >
              <path d="M9 0h1.98c.144.715.54 1.617 1.235 2.512C12.895 3.389 13.797 4 15 4v2c-1.753 0-3.07-.814-4-1.829V11a5 5 0 1 1-5-5v2a3 3 0 1 0 3 3z" />
            </svg>
            {`@multipro.id`}
          </a>
          <a href={`https://multipro.co.id`} target="blank">
            <i className="bi bi-globe"></i>
            {`multipro.co.id`}
          </a>
        </FooterPart>
      </div>
      <div style={{ display: 'flex', gap: '0.5rem', alignItems: 'center' }}>
        <p className={style.text_container}>
          PT Multipro Jaya Prima (Multipro.id) adalah penyedia solusi Enterprise IT Infrastructure, Data Center & Security sejak 1997. Kami merupakan Authorized Partner & Mitra Resmi di Indonesia untuk APC by Schneider Electric, HPE (Hewlett Packard Enterprise), Dell, Asus, Lenovo, Aruba Networks, Ruijie, Fortinet, Palo Alto, dan Cisco.
        </p>
      </div>
    </div>
  );
}

export default Footer;
